/* $(".js-accordion-button").on("click", function () {
	$(this).next().slideToggle();
	$(this).toggleClass("on");
}); */

/* const jsaccordionbutton = document.querySelector(".js-accordion-button");

jsaccordionbutton.addEventListener('click',function(){
    jsaccordionbutton.classList.toggle('on');
}, false);
 */

function change(e){
   const on_open =e.target;
   const elm = e.target.nextElementSibling;
   on_open.classList.toggle("on");
   elm.classList.toggle("open"); 
   if(elm.classList.contains("open")){
      elm.style.height = elm.scrollHeight + 'px';
   }else{
      elm.style.height = "0";
   }
}